import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SyllabusQuery } from '@examdojo/category/v2';
import { environment } from '@examdojo/core/environment';
import { PosthogErrorHandlingService } from '@examdojo/core/posthog';
import { AuthService, UserQuery } from '@examdojo/user';
import { combineLatest, filter, first, map, merge, take, tap } from 'rxjs';

@Injectable()
export class PosthogUserTraitsService {
  constructor(
    private readonly authService: AuthService,
    private readonly userQuery: UserQuery,
    private readonly posthogErrorHandlingService: PosthogErrorHandlingService,
    private readonly syllabusQuery: SyllabusQuery,
  ) {
    merge(this.setIdentityOnLogin(), this.setCourse(), this.resetOnLogout()).pipe(takeUntilDestroyed()).subscribe();
  }

  private readonly onboardedUser$ = this.userQuery.onboardedUser$.pipe(first(Boolean));

  private setIdentityOnLogin() {
    return this.onboardedUser$.pipe(
      tap((user) => {
        this.posthogErrorHandlingService.identifyUser(user.id, {
          first_name: user.first_name,
          last_name: user.last_name,
          email: user.email,
          app_version: environment.release_version,
        });
      }),
    );
  }

  private setCourse() {
    return combineLatest([this.onboardedUser$, this.syllabusQuery.active$]).pipe(
      map(([user, syllabus]) => {
        if (syllabus) {
          return {
            syllabus: syllabus.name,
            course_level: user.course_level,
          };
        }

        return;
      }),
      filter(Boolean),
      take(1),
      tap((traits) => {
        this.posthogErrorHandlingService.setUserTraits(traits);
      }),
    );
  }

  private resetOnLogout() {
    return this.authService.hasLoggedOut$.pipe(
      tap(() => {
        this.posthogErrorHandlingService.resetUser();
      }),
    );
  }
}
